export default __webpack_public_path__ + "static/compareItemImg5-b1cfc015250a7c124cb71ef938432e48.png";